import { deleteDistrict } from "../../../../../actions/Utilities/District";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteDistrict = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteDistrict(ids), {
    onSuccess: (res) => {
      queryClient.invalidateQueries(["GetDistrict"]);
      toast.fire(
        "Success",
        "District has been deactivated successfully",
        "success"
      );
    },
    onError: (error) => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate District",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteDistrict;
